export const removeEmptyKeys = (obj) => {
    for (let key in obj) {
      if (obj[key] === ""  || obj[key] === null ) {
        delete obj[key];
      }
    }
  }
  